import BaseModel from "../../../core/components/input-widget/BaseModel";
import {uuid} from "vue-uuid";

export default class SettlementBatchPaymentItemModel extends BaseModel {
  uuid = null;
  settlement_uuid = null;
  settlement = null;
  amount = null;
  reference_number = null;
  reconciled = false;
  uniqueKey = uuid.v4();
  beneficiary_relation_uuid = null;
  beneficiaries = []
  initial_amount = null;
  converted_amount = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    settlement_uuid: 'required',
    amount: 'required|min_value:0.1',
  };

  attributeLabels = {
  };

  attributeHints = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initial_amount = this.amount
  }
}
